interface IconProps {
  fill: string
  className?: string
  size?: number
}

export const LactateIcon = ({ fill, className = "", size = 13 }: IconProps) => {
  return (
    <svg
      className={className}
      width={size * 0.77}
      height={size}
      viewBox="0 0 10 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.51562 2.61121C6.84011 1.83105 6.07983 1.12855 5.24883 0.516674C5.17527 0.465143 5.08763 0.4375 4.99781 0.4375C4.908 0.4375 4.82036 0.465143 4.7468 0.516674C3.91733 1.1288 3.15852 1.8313 2.48438 2.61121C0.981016 4.33769 0.1875 6.15769 0.1875 7.87488C0.1875 9.15123 0.69453 10.3753 1.59705 11.2778C2.49957 12.1803 3.72365 12.6874 5 12.6874C6.27635 12.6874 7.50043 12.1803 8.40295 11.2778C9.30547 10.3753 9.8125 9.15123 9.8125 7.87488C9.8125 6.15769 9.01898 4.33769 7.51562 2.61121ZM8.0543 8.38566C7.94085 9.01933 7.63599 9.60302 7.18074 10.0582C6.7255 10.5133 6.14174 10.8181 5.50805 10.9314C5.48471 10.9351 5.46113 10.9371 5.4375 10.9374C5.32776 10.9373 5.22203 10.8961 5.14129 10.8217C5.06056 10.7474 5.0107 10.6455 5.00162 10.5361C4.99253 10.4267 5.02488 10.3179 5.09225 10.2313C5.15961 10.1447 5.25708 10.0865 5.36531 10.0684C6.27148 9.91582 7.04039 9.14691 7.19406 8.2391C7.2135 8.12466 7.2776 8.02263 7.37226 7.95545C7.46692 7.88828 7.58439 7.86146 7.69883 7.88089C7.81327 7.90033 7.91529 7.96443 7.98247 8.05909C8.04965 8.15375 8.07647 8.27122 8.05703 8.38566H8.0543Z"
        fill={fill}
      />
    </svg>
  )
}
